import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getCmdbForgeContextTokenUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/forge.tsx';
import type { WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { FetchForgeContextTokenFunction } from '../../types.tsx';

export const createFetchForgeCmdbContextToken =
	(workspaceId: WorkspaceId): FetchForgeContextTokenFunction =>
	({ extension, extensionData }) => {
		const useWorkspaceAri = true;
		const options = {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({ extension, extensionData, useWorkspaceAri }),
		};
		return performPostRequest(getCmdbForgeContextTokenUrl(workspaceId), options);
	};
